import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';

domReady(() => {
  const swiperConfig = {
    navigation: {
      nextEl: '.swiper-btn-arrows .swiper-button-next',
      prevEl: '.swiper-btn-arrows .swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    watchOverflow: true,
    spaceBetween: 20,
    slidesPerView: 1,
    breakpoints: {
      360: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      992: { slidesPerView: 3 },
    },
  };

  const sliders = [
    {
      selector: '.swiperAllNews',
      navigation: {
        nextEl: '.all-news-arrows .swiper-button-next',
        prevEl: '.all-news-arrows .swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination.all-news-pagination',
      },
    },
    {
      selector: '.swiperMontmagny',
      navigation: {
        nextEl: '.montmagny-arrows .swiper-button-next',
        prevEl: '.montmagny-arrows .swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination.montmagny-pagination',
      },
    },
    {
      selector: '.swiperLaPocatiere',
      navigation: {
        nextEl: '.laPocatiere-arrows .swiper-button-next',
        prevEl: '.laPocatiere-arrows .swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination.laPocatiere-pagination',
      },
    },
    {
      selector: '.swiperTemiscouata',
      navigation: {
        nextEl: '.temiscouata-arrows .swiper-button-next',
        prevEl: '.temiscouata-arrows .swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination.temiscouata-pagination',
      },
    },
  ];

  sliders.map((slider) => {
    return new Swiper(slider.selector, {
      ...swiperConfig,
      navigation: slider.navigation,
      pagination: slider.pagination,
    });
  });

  const tabs = document.querySelectorAll('.news-block__inner__tabs .tab');
  const carrousels = document.querySelectorAll('.news-block__inner__carrousel');
  const swiperArrows = document.querySelectorAll('.swiper-btn-arrows');
  const pagination = document.querySelectorAll('.swiper-pagination-news');
  const navigationWrapper = document.querySelectorAll(
    '.carrousel-news__navigation'
  );

  // Function to show the selected tab content
  function showTabCarrousel(tabIndex) {
    // Reset all tabs, carousels, and swiper arrows
    tabs.forEach((tab) => {
      tab.classList.remove('active');
      tab.setAttribute('aria-selected', 'false');
    });
    carrousels.forEach((carrousel) => (carrousel.style.display = 'none'));
    swiperArrows.forEach((arrowSet) => (arrowSet.style.display = 'none'));
    navigationWrapper.forEach((navSet) => (navSet.style.display = 'none'));
    pagination.forEach(
      (paginationSet) => (paginationSet.style.display = 'none')
    );

    // Activate the selected tab
    tabs[tabIndex].classList.add('active');
    tabs[tabIndex].setAttribute('aria-selected', 'true');

    // Show the corresponding carrousel and swiper arrows
    carrousels[tabIndex].style.display = 'flex';
    swiperArrows[tabIndex].style.display = 'flex';
    navigationWrapper[tabIndex].style.display = 'flex';
    pagination[tabIndex].style.display = 'flex';
  }

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => showTabCarrousel(index));
    tab.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') {
        const nextIndex = (index + 1) % tabs.length;
        tabs[nextIndex].focus();
        showTabCarrousel(nextIndex);
      } else if (event.key === 'ArrowLeft') {
        const prevIndex = (index - 1 + tabs.length) % tabs.length;
        tabs[prevIndex].focus();
        showTabCarrousel(prevIndex);
      } else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        showTabCarrousel(index);
      }
    });
  });

  // Initially show the first tab as active
  showTabCarrousel(0);
});
